// extracted by mini-css-extract-plugin
export default {"container":"WtQgVQ","disabled":"VPrtTW","characterScope":"lipwJF"};